import React from 'react';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { LinkWrapper } from '../../components/link-wrapper';
import { cleanFont } from '../../utils/font-utils/clean-font';
const FooterLink = ({ href, text, textColor, fontFamily, }) => {
    return (React.createElement("a", { className: "so-global-footer-text", style: Object.assign(Object.assign({ color: textColor }, (fontFamily ? { fontFamily: cleanFont(fontFamily) } : {})), { textDecoration: 'none' }), target: "_blank", href: href || undefined },
        React.createElement(LinkWrapper, { fontWeight: "inherit" },
            React.createElement(BdiWrapper, { text: text }))));
};
export default FooterLink;
//# sourceMappingURL=footer-link.js.map